export class SpecialPeriodModel {
    public specialPeriodHashId: string;
    public specialPeriodName: string;
    public specialPeriodStartTime: string;
    public specialPeriodEndTime: string;
    public sunFlag: boolean = false;
    public monFlag: boolean = true;
    public tueFlag: boolean = true;
    public wedFlag: boolean = true;
    public thuFlag: boolean = true;
    public friFlag: boolean = true;
    public satFlag: boolean = false;
    public isChecked:boolean;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/specialperiod/models/specialperiod.model.ts